import { render, staticRenderFns } from "./l-form-check.vue?vue&type=template&id=5d452c9e&"
import script from "./l-form-check.vue?vue&type=script&lang=js&"
export * from "./l-form-check.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports